import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { AjusteEstoqueComponent } from './ajuste-estoque.component';
import { AjusteEstoqueEditComponent } from './ajuste-estoque-edit/ajuste-estoque-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [AjusteEstoqueComponent, AjusteEstoqueEditComponent]
})
export class AjusteEstoqueModule { }
